<template>
    <div id="civii-container">

        <div v-if="show_back && chatIsOpen" class="civii-container-back" @click="closeChat"/>

        <chat-bubble v-if="!full_size"/>

        <div :class="[{active: chatIsOpen}, 'civii-container' + (full_size?'-full':'')]">

            <top-menu />

            <div ref="chatBox" class="civii-content">

                <template v-if="messages.length > 0">
                    <div v-for="(message, index) in messages" :key="'msg' + index">
                        <answer-builder :answer="message"/>
                    </div>
                </template>

                <options />

                <accordion-checklist />

                <calendar-widget />

                <cancelaccept
                    @accept="acceptWidget"
                    @cancel="cancelWidget"
                    v-if="cancelAccept !== null"
                    :type="cancelAccept.type || null"
                />

                <camera-widget />

                <upload-widget />

                <div v-show="loading" class="civii-messages-container">
                    <div class="civii-message left">
                        <div  class="civii-message-content">
                            <div class="civii-loading">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="civii-footer civii-input">
                <div class="civii-message">
                    <input
                        type="text"
                        :placeholder="placeholder"
                        @keyup.enter="sendMessage"
                        v-model="message"
                        :disabled="loading || disableInput"
                        @keyup.up="lastMessage"
                        @keyup.down="nextMessage"
                        ref="messageInput"
                    />
                </div>
                <div @click="sendMessage" class="civii-send">
                    <i class="civii-icon-paper-plane"></i>
                </div>
            </div>

            <audio ref="beep">
            <source src="../static/sound/beep2.mp3" type="audio/mpeg">

            </audio>
        </div>
    </div>
</template>

<script>
import ChatBubble from './components/ChatBubble/ChatBubble.vue'
import TopMenu from './components/TopMenu/TopMenu.vue'

import { mapActions, mapMutations, mapState } from 'vuex'

import AnswerBuilder from './components/answers/AnswerBuilder.js'
import Normal from './components/answers/Normal/Normal.vue'
import Options from './components/widgets/Options/Options.js'
import AccordionChecklist from './components/widgets/AccordionChecklist/AccordionChecklist.vue'
import CalendarWidget from './components/widgets/CalendarWidget/CalendarWidget'
import Calendar from './components/widgets/Calendar/Calendar'
import cancelaccept from './components/widgets/CancelAccept/CancelAccept.vue'
import CameraWidget from './components/widgets/CameraWidget/CameraWidget.vue'
import UploadWidget from './components/widgets/UploadWidget/UploadWidget.vue'

async function sendMessageToCivii(component, token){
    if (!component.loading && component.enable) {
        let funcArgs = component.message.split(' ')
        if (funcArgs.length === 2 && funcArgs[0] === 'testCiviiWorkspace') {
            await component.$store.dispatch('testWorkspace', funcArgs[1])
        } else {
            component.messagesList.push(component.message)
            component.currentMessage = component.messagesList.length

            if(component.talkingWithAgent){
                component.sendMessageToAgent(component.message);
                component.message = '';
            } else {
                await component.$store.dispatch('sendMessage', {message: component.message, token: token});
            }
        }
    }
}

export default {
    name: 'App',
    components: {
        ChatBubble,
        TopMenu,
        AnswerBuilder,
        Normal,
        Options,
        AccordionChecklist,
        CalendarWidget,
        Calendar,
        cancelaccept,
        CameraWidget,
        UploadWidget
    },
    data () {
        return {
            message: '',
            placeholder: window.civiiConf.inputPlaceholder,
            messagesList: [],
            currentMessage: null,
            full_size: window.civiiConf.full_size,
            show_back: window.civiiConf.show_back,
            db: '',
            enableChat: true
        }
    },
    computed: {
        ...mapState([
            'enable',
            'talkingWithAgent',
            'messages','context',
            'chatIsOpen',
            'loading',
            'sound',
            'cancelAccept',
            'disableInput'
            ])
    },
    watch: {
        chatIsOpen () {
            this.$refs.messageInput.focus()
            this.scrollToBottom()
        },
        messages () {
            this.scrollToLastMessage()
        },
        loading (newValue, oldValue) {
            if (oldValue && !newValue) {
                if (this.sound) {
                    this.$refs.beep.play()
                }
                this.$nextTick(function () {
                    this.$refs.messageInput.focus()
                })
            } else if (!oldValue && newValue) {
                this.message = ''
            }
        }
    },
    methods: {
        ...mapMutations(['setDisableInput']),
        ...mapActions(['getCiviiStatus']),
        ...mapActions('civiiChat', ['sendMessageToAgent']),
        async closeChat () {
            await this.$store.dispatch('chatState', false)
        },
        scrollToLastMessage () {
            this.$nextTick(function () {
                try {
                    let lastMessages = document.getElementsByClassName('civii-message right')
                    let topPos = lastMessages[lastMessages.length - 1].offsetTop
                    this.$refs.chatBox.scrollTop = topPos
                } catch (err) {
                    // do nothing
                }
            })
        },
        scrollToBottom () {
            this.$nextTick(function () {
                this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight
            })
        },
        async sendMessage () {
            sendMessageToCivii(this, "token");
        },
        lastMessage () {
            this.currentMessage--
            if (this.currentMessage < 0) {
                this.currentMessage = 0
            }
            this.message = this.messagesList[this.currentMessage]
        },
        nextMessage () {
            this.currentMessage++
            if (this.currentMessage > this.messagesList.length) {
                this.currentMessage--
                this.message = ''
            } else {
                this.message = this.messagesList[this.currentMessage]
            }
        },
        acceptWidget () {
            this.$store.dispatch('sendMessage', {message: 'true', textShowed: '✔'})
        },
        cancelWidget () {
            this.$store.dispatch('sendMessage', {message: 'false', textShowed: '✖'})
        }
    },
    mounted () {
        this.scrollToBottom();
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue